import React from "react";
import { ChevronRight } from "lucide-react";
import { MainMenuDropdown, MainMenuHamburgerIcon } from "./MainPanelHeader";
import { MAIN_MENU_HOVER_SURFACE_CLASS } from "./constants";
import Tooltip from "../ui/Tooltip";

const MainPanelCollapsedTab = React.memo(function MainPanelCollapsedTab({
  isCollapsed,
  isMobilePanelViewport,
  mobilePanelCoversMenu,
  position,
  swipeHandlers,
  onExpand,
  onNewProject,
  onUploadFilesClick,
  onUploadFolderClick,
  onExportXml,
  onExportEnvironmentZip,
  onQuickSaveEnvironment,
  onSaveCloudNamed,
  onOpenCloudProjects,
  onExportDeploymentBundle,
  onLoadEnvironmentClick,
  onUndo,
  onRedo,
  onOpenVisibilitySettings,
  onOpenShortcuts,
  onOpenGetUpdates,
  onOpenSendFeedback,
  onOpenAbout,
  onOpenPrivacySettings,
  exportProjectName,
  onExportProjectNameChange,
  onRefreshExportProjectName,
  quickProjectSavePending,
  cloudActionPending,
  cloudSaveMatchesCurrent,
}) {
  if (!isCollapsed) return null;

  return (
    <div
      dir="ltr"
      className={`main-menu-collapsed-tab fixed flex flex-row items-center justify-center rounded-r-md border border-l-0 border-gray-700 text-gray-300 outline-none focus:outline-none${mobilePanelCoversMenu ? " main-menu-collapsed-tab-mobile-covered" : ""}`}
      {...swipeHandlers}
      style={{
        display: "flex",
        position: "fixed",
        top: position.top ?? 10,
        left: 0,
        zIndex: (position.zIndex ?? 20) + 1,
        width: "3.5rem",
        height: "2.5rem",
        backgroundColor: "var(--panel-surface)",
        gap: 0,
        paddingLeft: 0,
        paddingRight: 0,
        boxSizing: "border-box",
      }}
    >
      {isMobilePanelViewport ? (
        <>
          <Tooltip content="Open main menu" side="right">
            <button
              type="button"
              onClick={onExpand}
              className={`${MAIN_MENU_HOVER_SURFACE_CLASS} flex h-full min-w-0 flex-1 basis-0 cursor-pointer items-center justify-center rounded-none border-0 bg-transparent py-0 pr-0 pl-1.5 text-gray-200 outline-none focus:outline-none`}
              aria-label="Open main menu"
            >
              <MainMenuHamburgerIcon />
            </button>
          </Tooltip>
          <Tooltip content="Show panel" side="right">
            <button
              type="button"
              onClick={onExpand}
              className={`${MAIN_MENU_HOVER_SURFACE_CLASS} flex h-full min-w-0 flex-1 basis-0 cursor-pointer items-center justify-center rounded-r-md border-0 bg-transparent p-0 px-2 text-gray-300 outline-none focus:outline-none`}
              aria-label="Show panel"
            >
              <ChevronRight className="h-5 w-5" strokeWidth={2.5} aria-hidden />
            </button>
          </Tooltip>
        </>
      ) : (
        <>
          <MainMenuDropdown
            contentAlign="start"
            onNewProject={onNewProject}
            onUploadFilesClick={onUploadFilesClick}
            onUploadFolderClick={onUploadFolderClick}
            onExportXml={onExportXml}
            onExportEnvironmentZip={onExportEnvironmentZip}
            onQuickSaveEnvironment={onQuickSaveEnvironment}
            onSaveCloudNamed={onSaveCloudNamed}
            onOpenCloudProjects={onOpenCloudProjects}
            onExportDeploymentBundle={onExportDeploymentBundle}
            onLoadEnvironmentClick={onLoadEnvironmentClick}
            onUndo={onUndo}
            onRedo={onRedo}
            onOpenVisibilitySettings={onOpenVisibilitySettings}
            onOpenShortcuts={onOpenShortcuts}
            onOpenGetUpdates={onOpenGetUpdates}
            onOpenSendFeedback={onOpenSendFeedback}
            onOpenAbout={onOpenAbout}
            onOpenPrivacySettings={onOpenPrivacySettings}
            exportProjectName={exportProjectName}
            onExportProjectNameChange={onExportProjectNameChange}
            onRefreshExportProjectName={onRefreshExportProjectName}
            quickProjectSavePending={quickProjectSavePending}
            cloudActionPending={cloudActionPending}
            cloudSaveMatchesCurrent={cloudSaveMatchesCurrent}
            menuTriggerClassName={`${MAIN_MENU_HOVER_SURFACE_CLASS} flex h-full min-w-0 flex-1 basis-0 items-center justify-center rounded-none border-0 bg-transparent py-0 pr-0 pl-1.5 text-gray-200 cursor-pointer outline-none focus:outline-none`}
          />
          <Tooltip content="Show panel" side="right">
            <button
              type="button"
              onClick={onExpand}
              className={`${MAIN_MENU_HOVER_SURFACE_CLASS} flex h-full min-w-0 flex-1 basis-0 cursor-pointer items-center justify-center rounded-r-md border-0 bg-transparent p-0 text-gray-300 outline-none focus:outline-none`}
              aria-label="Show panel"
            >
              <ChevronRight className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden />
            </button>
          </Tooltip>
        </>
      )}
    </div>
  );
});

export default MainPanelCollapsedTab;
